import { connect } from "react-redux";
import * as PermissionsConstants from "../../../const/constants";
import React, { useState, useEffect, useCallback } from "react";

export const CONSIGNEE_ID_FROM = "consigneeidfrom";
export const CONSIGNEE_ID_TO = "consigneeidto";
export const SHIPPER_ID_FROM = "shipperidfrom";
export const SHIPPER_ID_TO = "shipperidto";
export const CUSTOMER_ID_FROM = "customeridfrom";
export const CUSTOMER_ID_TO = "customeridto";

const TransactionIdLookupWithNewStyle = (props) => {
  
  return (
    <div>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(TransactionIdLookupWithNewStyle);
